import React from 'react';
import Reflux from 'reflux';
import { Map, List } from 'immutable';
import SimplePager from 'shared/components/misc/simplePager.jsx';
import { Button } from 'bootstrap';
import ActivityAuditListStore from 'flux/stores/ActivityAuditListStore';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import UserSessionStore from 'flux/stores/UserSessionStore';
import ActivityAuditListActions from 'flux/actions/ActivityAuditListActions';
import ConfirmActions from 'flux/actions/ConfirmActions';
import role from 'shared/lib/role';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import CuesheetRowActions from 'flux/actions/cuesheet/CuesheetRowActions';
import CuesheetColumnActions from 'flux/actions/cuesheet/CuesheetColumnActions';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import { getLocalMoment } from 'time';
import RowItem from 'main/components/activityAudit/rowItem';
import cellHelper from 'main/components/show/cuesheet/cellHelper';
import {
  WithTooltip,
  Icon,
  Avatar as UserAvatar,
} from '@shoflo-rundown/polymer.legacy';
import ColumnItem from 'main/components/activityAudit/columnItem';
import SimpleSpinner from 'shared/components/misc/simpleSpinner.jsx';
import { PasteModes } from 'shared/flux/stores/cuesheet/CuesheetConstants';
import RTE from 'shared/components/rte/rte.jsx';

/**
 * Activity Audit List
 *
 */
export default React.createClass({
  mixins: [
    Reflux.ListenerMixin,
    Reflux.connect(ActivityAuditListStore, 'activityAudit'),
    Reflux.connectFilter(CuesheetStore, 'show', (st) => st.get('show')),
    Reflux.connectFilter(CuesheetStore, 'itemSetListId', (st) =>
      st.get('itemSetListId'),
    ),
    Reflux.connectFilter(CuesheetStore, 'columnOrder', (st) =>
      st.get('columnOrder'),
    ),
    Reflux.connectFilter(CuesheetStore, 'rows', (st) => st.get('rows')),
    Reflux.connectFilter(CuesheetStore, 'itemSetId', (st) => {
      return st.get('rowMap') ? st.get('rowMap').keySeq().first() : null;
    }),
    Reflux.connect(UserSessionStore, 'user'),
  ],

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  displayName: 'ActivityAuditList',

  _hasEventAdminRole() {
    let params = this.context.router.state.params;
    let user = this.state.user;
    let { teamId, eventId } = params;

    if (!user) return;

    return role.hasEventAdminRole(user, teamId, eventId);
  },

  _hasEventContributorRole() {
    let params = this.context.router.state.params;
    let user = this.state.user;
    let { teamId, eventId } = params;

    if (!user) return;

    return role.hasEventContributorRole(user, teamId, eventId);
  },

  /**
   * Main render
   */
  render() {
    const { show } = this.state;

    const visible = this.state.activityAudit.get('visible');

    if (!visible || !show) return null;

    return (
      <div className="af-container">
        <div className="af-container-header">
          {this._getListTitleNode()}
          <a
            className="af-container-header-close fa fa-times"
            onClick={() => ActivityAuditListActions.toggleVisibility()}
          ></a>
        </div>
        {this._getRefreshButtonNode()}
        {this._getPaginationNode()}
        {this._getListNode()}
      </div>
    );
  },

  /**
   * Get the title node
   */
  _getListTitleNode() {
    const { show } = this.state;
    const audit = this.state.activityAudit;

    let subTitle = show.get('title'),
      mainTitle = 'All Show Activity',
      selectedItem = audit.get('selectedItem'),
      selectedColumn = audit.get('selectedColumn'),
      selectedField = audit.get('selectedField'),
      listType = audit.get('listType'),
      numberAdjusted = null;

    let clearNode = (
        <div
          className="af-container-header-all-wrapper"
          onClick={() => this._populate()}
        >
          <Icon className="af-container-header-all" name="arrow-left" />{' '}
          <span className="af-container-header-all-see">SEE ALL</span>
        </div>
      ),
      viewDeletedRowsNode = (
        <Button
          className="af-deleted-filter-btn rows"
          onClick={() => this._populateForSoftDeletedItemRows()}
        >
          View Deleted Rows
        </Button>
      ),
      viewDeletedColumnsNode = (
        <Button
          className="af-deleted-filter-btn columns"
          onClick={() => this._populateForSoftDeletedColumns()}
        >
          View Deleted Columns
        </Button>
      );

    // TODO: temp solution and we will comeback and make sure selected item is present so we can have the history of a deleted item
    if (typeof selectedItem !== 'undefined') {
      numberAdjusted = selectedItem.get('numberAdjusted');
      viewDeletedRowsNode = null;

      let itemTitle = `| ${selectedItem.get('title')}`;

      if (typeof numberAdjusted === 'undefined')
        numberAdjusted = (
          <span className="af-list-item-deleted">(DELETED)</span>
        );
      if (typeof selectedItem.get('title') === 'undefined') itemTitle = '';

      subTitle = (
        <span>
          {' '}
          Item {numberAdjusted} | {itemTitle}
        </span>
      );
      mainTitle = 'Cell Edit History';
    } else if (listType === 'softDeletedItemRows') {
      mainTitle = 'Deleted Rows';
      viewDeletedRowsNode = null;
      viewDeletedColumnsNode = null;
    } else if (listType === 'softDeletedColumns') {
      mainTitle = 'Deleted Columns';
      viewDeletedRowsNode = null;
      viewDeletedColumnsNode = null;
    } else {
      clearNode = null;
    }

    if (selectedColumn) {
      subTitle = (
        <span>
          {' '}
          Item {numberAdjusted} | {selectedColumn} Column
        </span>
      );
    }

    if (selectedField === 'title') {
      subTitle = <span> Item {numberAdjusted} | Item Column</span>;
    }

    if (selectedField === 'description') {
      subTitle = <span> Item {numberAdjusted} | Item Column</span>;
    }

    return (
      <div>
        {clearNode}
        <span className="af-container-header-show-title">{mainTitle}</span>
        <span className="af-container-header-title">{subTitle}</span>
        <span className="af-container-filter-btns">
          {viewDeletedColumnsNode}
          {viewDeletedRowsNode}
        </span>
      </div>
    );
  },

  _getRefreshButtonNode() {
    return (
      <a
        className="af-container-refresh fa fa-refresh"
        onClick={() => ActivityAuditListActions.refresh()}
      ></a>
    );
  },

  _getListNode() {
    let state = this.state.activityAudit;
    // items = state.getIn(['list', 'items']);

    let itemNodes = this._getListItemNodes();

    if (state.get('loading')) {
      return (
        <div className="af-list-spinner">
          <SimpleSpinner />
        </div>
      );
    }

    if (!itemNodes.size) {
      return (
        <div>
          <div className="af-list-no-activity text-center">
            <p>No activity found...</p>
          </div>
        </div>
      );
    }

    return <div className="af-list">{itemNodes}</div>;
  },

  _getListItemNodes() {
    let state = this.state.activityAudit,
      items = state.getIn(['list', 'items']);

    if (!items || !items.size) return List();

    let itemNodes = items.map(this._getListItemNode).filter((x) => x);

    return itemNodes;
  },

  _getListItemNode(item) {
    // const itemNumber = item.has('itemNumber') ? ` ${item.get('itemNumber')}` : null;
    // const itemTitle = item.has('itemTitle') ? item.get('itemTitle') : null;
    const column = item.has('columnTitle') ? item.get('columnTitle') : null;

    const changes = item.getIn(['payload', 'changes', 'rteState']);
    const title = item.getIn(['payload', 'changes', 'rteTitleState']);
    const columnTitle = item.getIn(['payload', 'changes', 'title']);
    const durationInSeconds = item.getIn([
      'payload',
      'changes',
      'durationInSeconds',
    ]);
    const presetDurationInSeconds = item.getIn([
      'payload',
      'changes',
      'presetDurationInSeconds',
    ]);
    const startOn = item.getIn(['payload', 'changes', 'startOn']);
    const description = item.getIn([
      'payload',
      'changes',
      'rteDescriptionState',
    ]);
    const titleRow = item.getIn(['payload', 'changes', 'titleRow']);
    const hasLockRow = item.hasIn(['payload', 'changes', 'locked']);
    const cellFormatting = item.getIn(['payload', 'changes', 'format'])
      ? item.getIn(['payload', 'changes', 'format'])
      : null;
    const method = item.get('method');

    if (method === 'itemSet.createItemRows')
      return this._getCreatedItemRow(item, 'Added a new ');
    if (method === 'itemSet.createGlobalElementItemRows')
      return this._getCreatedItemRow(item, 'Added a new global element ');
    if (method === 'itemSet.restoreItemRow')
      return this._getUpdateItemRow(item, 'Restored ');

    if (method === 'itemSet.updateItemRow') {
      if (typeof durationInSeconds !== 'undefined')
        return this._getUpdateItemRowWithoutTitle(
          item,
          'Changed ',
          ' duration',
          true,
        );
      if (typeof presetDurationInSeconds !== 'undefined')
        return this._getUpdateItemRowWithoutTitle(
          item,
          'Changed ',
          ' preset time',
          true,
        );
      if (typeof startOn !== 'undefined')
        return this._getUpdateItemRowWithoutTitle(
          item,
          'Changed ',
          ' start time',
          true,
        );
      if (description)
        return this._getUpdateItemRow(
          item,
          ' ',
          undefined,
          description,
          '',
          '',
          'Changed the Item description to:',
        );
      if (title) {
        return this._getUpdateItemRow(
          item,
          ' ',
          undefined,
          title,
          '',
          '',
          'Changed the Item title to:',
        );
      }
      if (hasLockRow) {
        const lockRow = item.getIn(['payload', 'changes', 'locked']);
        if (lockRow)
          return this._getUpdateItemRowWithoutTitle(item, 'Locked ', undefined);
        if (!lockRow)
          return this._getUpdateItemRowWithoutTitle(
            item,
            'Unlocked ',
            undefined,
          );
      }
    }

    if (method === 'itemSet.updateItemRowPresentation') {
      if (titleRow === true)
        return this._getUpdateItemRowWithoutTitle(
          item,
          'Converted ',
          ' to a Title Row',
        );
      if (titleRow === false)
        return this._getUpdateItemRowWithoutTitle(
          item,
          'Converted ',
          ' to an Item Row',
        );
    }

    if (method === 'itemSet.removeGlobalElementReference') {
      return this._getUpdateItemRowWithoutTitle(
        item,
        'Converted GE row ',
        ' to a normal row',
      );
    }

    if (method === 'itemSet.publishLatestGlobalElementRowChangesToShowRow') {
      return this._getUpdateItemRowWithoutTitle(
        item,
        'Retrieved latest GE changes for ',
        ' ',
      );
    }

    if (method === 'itemSet.moveRow')
      return this._getUpdateItemRow(item, 'Re-ordered ', ' ');
    if (
      method === 'itemSet.softDeleteItemRows' &&
      item.getIn(['payload', 'mode']) === PasteModes.Cut
    ) {
      return this._getSoftDeleteItemRows(item, 'cut ', ' ');
    }
    if (method === 'itemSet.softDeleteItemRows')
      return this._getSoftDeleteItemRows(item, 'Deleted ', ' ');

    if (method === 'itemSet.updateMultipleItemRowCells') {
      if (!changes && !cellFormatting) return null;

      return this._getUpdateItemRowCell(item, changes, column, cellFormatting);
    }

    if (method === 'itemSetList.updateColumn')
      return this._getUpdateColumn(
        item,
        columnTitle,
        'Changed the column name to:',
        column,
      );
    if (method === 'itemSetList.softDeleteColumn')
      return this._getSoftDeletedColumn(item, column, 'Deleted column |');
    if (method === 'itemSetList.createColumn')
      return this._getUpdateColumn(item, column, 'Added a new column');
    if (method === 'itemSetList.restoreColumn')
      return this._getUpdateColumn(item, column, 'Restored column |');
    // Kept as this might be brought back
    if (method === 'itemSetList.moveUserColumn') return; //this._getUpdateColumn(item, column, 'moved');
  },

  /**
   * Get Item For Soft Deleted Row
   */
  _getSoftDeleteItemRows(
    item,
    prefix,
    suffix,
    changes,
    title,
    possessive,
    action,
  ) {
    let { rows } = this.state;

    /*
     * Only rows that haven't been restored should have the restore button
     */
    let handleRestore =
      rows &&
      rows.findIndex((row) => {
        return row.get('path')[2] === item.getIn(['rowIds', 0]);
      }) !== -1
        ? null
        : (item) => this._handleRestoreRow(item);

    return this._getItemRow(
      item,
      prefix,
      suffix,
      changes,
      title,
      possessive,
      action,
      handleRestore,
      null,
      true,
    );
  },

  /**
   * Get Item For Updated Row
   */
  _getUpdateItemRow(item, prefix, suffix, changes, title, possessive, action) {
    if (title === 'noTitle') item = item.delete('itemTitle');

    return this._getItemRow(
      item,
      prefix,
      suffix,
      changes,
      title,
      possessive,
      action,
      this._handleRestoreItemFieldChange,
      this._populateForItemField,
    );
  },

  /**
   * Get Item For New Row
   */
  _getCreatedItemRow(item, prefix, suffix, changes, title, possessive, action) {
    item = item.delete('itemTitle').delete('itemNumber');

    return this._getItemRow(
      item,
      prefix,
      suffix,
      changes,
      title,
      possessive,
      action,
    );
  },

  /**
   * Get Generic Row Item
   */
  _getItemRow(
    item,
    prefix,
    suffix,
    changes,
    title,
    possessive,
    action,
    restoreHandler,
    historyHandler,
    disableIsLatestCheck,
  ) {
    let audit = this.state.activityAudit,
      selectedField = audit.get('selectedField'),
      isLatest = disableIsLatestCheck
        ? false
        : this._isLatestItemRowChangeForRow(item);

    return (
      <RowItem
        fieldType={selectedField}
        item={item}
        changes={changes}
        displayHistoryButton={true}
        displayRestoreButton={
          !isLatest &&
          ((restoreHandler && this._hasEventContributorRole()) ||
            (restoreHandler &&
              !this._hasEventContributorRole() &&
              this._hasEventAdminRole()))
        }
        onHistoryClick={() => historyHandler(item)}
        onRestoreClick={() => restoreHandler(item)}
        onNumberClick={() => this._scrollToItemRow(item)}
        prefix={prefix}
        suffix={suffix}
        possessive={possessive}
        action={action}
      />
    );
  },

  _scrollToItemRow(item) {
    let itemSetId = item.getIn(['payload', 'itemSetId']),
      rowId = item.getIn(['payload', 'rowId']);

    if (!itemSetId || !rowId) return;

    let cellSpec = null;

    if (item.hasIn(['payload', 'columnId'])) {
      cellSpec = {
        type: EditableCellTypes.Data,
        value: item.getIn(['payload', 'columnId']),
      };
    } else if (item.hasIn(['payload', 'changes', 'description'])) {
      cellSpec = { type: EditableCellTypes.ItemDescription };
    } else if (item.hasIn(['payload', 'changes', 'title'])) {
      cellSpec = { type: EditableCellTypes.ItemTitle };
    }

    CuesheetRowActions.scrollToRow(
      item.get('show'),
      itemSetId,
      rowId,
      cellSpec,
    );
  },

  _populateForItemField(item) {
    let params = this.context.router.state.params;

    let { teamId, eventId, showId } = params;

    let rowId = item.getIn(['payload', 'rowId']),
      fieldName = item.hasIn(['payload', 'changes', 'rteTitleState'])
        ? 'title'
        : 'description';

    ActivityAuditListActions.populateForItemField(
      teamId,
      eventId,
      showId,
      rowId,
      fieldName,
      1,
    );
  },

  /**
   * Restore logic for restoring a item title or description
   */
  _handleRestoreItemFieldChange(item) {
    /* eslint-disable no-unused-vars */
    const itemSetId = item.getIn(['payload', 'itemSetId']),
      rowId = item.getIn(['payload', 'rowId']),
      titleChange = item.getIn(['payload', 'changes', 'rteTitleState']),
      descChange = item.getIn(['payload', 'changes', 'rteDescriptionState']),
      field = titleChange ? 'rteTitleState' : 'rteDescriptionState',
      text = titleChange ? titleChange : descChange,
      cellType = titleChange
        ? EditableCellTypes.ItemTitle
        : EditableCellTypes.ItemDescription,
      rteState = titleChange
        ? item.getIn(['payload', 'changes', 'rteTitleState'])
        : item.getIn(['payload', 'changes', 'rteDescriptionState']);
    /* eslint-enable no-unused-vars */

    const cellSpec = Map({ type: cellType, value: cellType });

    ConfirmActions.prompt(
      `Do you want to restore the ${
        field === 'rteTitleState' ? 'title' : 'description'
      }?`,
      () => {
        CuesheetCellActions.saveItemFieldWithIds(
          itemSetId,
          rowId,
          cellSpec,
          Map(rteState),
        );
        /**
         * Refresh the list to show the new activity that just happened..
         */
        setTimeout(() => {
          ActivityAuditListActions.refresh();
        }, 1000);
      },
    );
  },

  _populateForSoftDeletedColumns() {
    let { params } = this.context.router.state;
    let { teamId, eventId, showId } = params;

    let itemSetListId = this.state.itemSetListId;

    ActivityAuditListActions.populateForSoftDeletedColumns(
      teamId,
      eventId,
      showId,
      itemSetListId,
      1,
    );
  },

  _populateForRowMethodName(methodName) {
    let params = this.context.router.state.params;

    let { teamId, eventId, showId } = params;

    ActivityAuditListActions.populateForMethodName(
      teamId,
      eventId,
      showId,
      methodName,
      1,
    );
  },

  _populateForSoftDeletedItemRows() {
    let params = this.context.router.state.params;
    let { teamId, eventId, showId } = params;

    let itemSetId = this.state.itemSetId;

    ActivityAuditListActions.populateForSoftDeletedItemRows(
      teamId,
      eventId,
      showId,
      itemSetId,
      1,
    );
  },

  /**
   * Restore logic for restoring a item title or description
   */
  _handleRestoreRow(item) {
    let itemSetId = item.getIn(['payload', 'itemSetId']),
      rowId = item.getIn(['payload', 'rowIds', 0]);

    ConfirmActions.prompt(
      'This will restore this item as the last row. Are you sure?',
      () => {
        CuesheetRowActions.restoreItemRow(itemSetId, rowId);
        /**
         * Refresh the list to show the new activity that just happened..
         */
        setTimeout(() => {
          ActivityAuditListActions.refresh();
        }, 1000);
      },
    );
  },

  _getUpdateItemRowCell(item, changes, column, cellFormatting) {
    let historyNode = null,
      restoreButtonNode,
      auditState = this.state.activityAudit,
      actionClasses = 'af-list-item-action-icon',
      wrapperClasses = 'af-list-item-wrapper',
      itemNumberNode = this._getListItemNumber(item),
      itemNumber = item.get('itemNumber');

    const isLatest = this._isLatestCellChangeForCell(item);

    let selectedItem = auditState.get('selectedItem'),
      selectedColumn = auditState.get('selectedColumn'),
      selectedField = auditState.get('selectedField');

    if (!selectedItem) {
      actionClasses = isLatest
        ? 'af-list-item-action-icon'
        : 'af-list-item-action-icons';
      historyNode = (
        <div
          onClick={() => this._populateForItemCell(item)}
          className="af-list-item-list-icon"
        >
          <Icon name="list" />
        </div>
      );
    }

    restoreButtonNode = isLatest ? null : (
      <div
        onClick={() => this._handleRestoreItemCellChange(item)}
        className="af-list-item-undo-icon"
      >
        <Icon name="undo" />
      </div>
    );

    if (!this._hasEventContributorRole()) {
      actionClasses = 'af-list-item-action-icon';
      restoreButtonNode = null;
    }

    if (itemNumber === '---') {
      actionClasses = 'af-list-item-action-icon';
      restoreButtonNode = null;
      historyNode = null;
      itemNumberNode = (
        <div className="af-list-item-number">
          <span className="af-list-item-number-value">
            <span></span>&nbsp;Item{' '}
            <span className="af-list-item-deleted">(DELETED)</span>
          </span>
        </div>
      );
    }

    let details = (
      <span>
        {itemNumberNode}
        {this._getListItemTitle(item)}
        <div className="af-list-item-action">
          Changed the <span>{column}</span> cell to:
        </div>
      </span>
    );

    if (
      selectedField === 'title' ||
      selectedColumn ||
      selectedField === 'description'
    ) {
      wrapperClasses += ' af-list-item-wrapper-minimal';
      details = null;
    }

    return (
      <div className={wrapperClasses}>
        {this._getListItemTimeStamp(item)}
        <div className={actionClasses}>
          <WithTooltip
            placement="top"
            delay={0}
            tip={TooltipConstants.CSActivityFeedListIcon}
          >
            <span>{historyNode}</span>
          </WithTooltip>
          <WithTooltip
            placement="top"
            delay={0}
            tip={TooltipConstants.CSActivityFeedUndoIcon}
          >
            <span>{restoreButtonNode}</span>
          </WithTooltip>
        </div>
        <div className="af-list-item expanded">
          {this._getListItemUser(item)}
          {details}
          <div className="af-list-item-changes">
            {this._getExpandableListItem(changes, cellFormatting)}
          </div>
        </div>
      </div>
    );
  },

  _populateForItemCell(item) {
    let params = this.context.router.state.params;

    let { teamId, eventId, showId } = params;

    let rowId = item.getIn(['payload', 'rowId']),
      columnId = item.getIn(['payload', 'columnId']);

    ActivityAuditListActions.populateForItemCell(
      teamId,
      eventId,
      showId,
      rowId,
      columnId,
      1,
    );
  },

  /**
   * Restore logic for a row+column combo (i.e. a cell)
   */
  _handleRestoreItemCellChange(item) {
    let itemSetId = item.getIn(['payload', 'itemSetId']),
      rowId = item.getIn(['payload', 'rowId']),
      columnId = item.getIn(['payload', 'columnId']),
      rteState = item.getIn(['payload', 'changes', 'rteState']);

    const cellSpec = Map({ type: EditableCellTypes.Data, value: columnId });

    const cellFormatting = item.getIn(['payload', 'changes', 'format'])
      ? item.getIn(['payload', 'changes', 'format'])
      : null;

    ConfirmActions.prompt('Do you want to restore the cell?', () => {
      CuesheetCellActions.saveDataCellTextWithIds(
        itemSetId,
        rowId,
        columnId,
        rteState,
        cellSpec,
        cellFormatting,
      );

      /**
       * Refresh the list to show the new activity that just happened..
       */
      setTimeout(() => {
        ActivityAuditListActions.refresh();
      }, 1000);
    });
  },

  _getUpdateItemRowWithoutTitle(item, prefix, suffix, possessive) {
    let itemRowWithoutTitle = this._getUpdateItemRow(
      item,
      prefix,
      suffix,
      undefined,
      'noTitle',
      possessive,
    );

    return <div>{itemRowWithoutTitle}</div>;
  },

  _getExpandableListItem(changes, format) {
    const inlineStyles = format ? cellHelper.getFormatStyles(format) : null;

    return (
      <div>
        <div style={inlineStyles} className="af-list-item-changes-content">
          <RTE readOnly rteState={changes} />
        </div>
      </div>
    );
  },

  /**
   * Get Item For Soft Deleted Column
   */
  _getSoftDeletedColumn(item, column, prefix, changes) {
    let { columnOrder } = this.state;

    /**
     * Only columns that haven't been restored should have the restore button
     */
    let handleRestore =
      columnOrder && columnOrder.indexOf(item.get('columnId')) !== -1
        ? null
        : () => this._handleRestoreColumn(item);

    return this._getColumn(item, column, prefix, changes, handleRestore);
  },

  /**
   * Restore logic for restoring a soft deleted column
   */
  _handleRestoreColumn(item) {
    ConfirmActions.prompt(
      'This will restore this column as the last column. Are you sure?',
      () => {
        CuesheetColumnActions.restoreColumn(item.get('columnId'));

        /**
         * Refresh the list to show the new activity that just happened..
         */
        setTimeout(() => {
          ActivityAuditListActions.refresh();
        }, 1000);
      },
    );
  },

  /**
   * Get Generic Row Item
   */
  _getColumn(item, column, prefix, changes, restoreHandler, historyHandler) {
    return (
      <ColumnItem
        item={item}
        column={column}
        changes={changes}
        displayHistoryButton={false}
        displayRestoreButton={
          (this._hasEventContributorRole() && restoreHandler) ||
          (!this._hasEventContributorRole() &&
            this._hasEventAdminRole() &&
            restoreHandler)
        }
        onHistoryClick={() => historyHandler(item)}
        onRestoreClick={() => restoreHandler(item)}
        onNumberClick={() => this._scrollToItemRow(item)}
        prefix={prefix}
      />
    );
  },

  /**
   * Get Item For Soft Deleted Column
   */
  _getUpdateColumn(item, column, prefix, changes) {
    return this._getColumn(item, column, prefix, changes);
  },

  _getListItemColumn(column) {
    return (
      <span className="af-list-item-column">
        <span />
        {column}
      </span>
    );
  },

  _getListItemNumber(item, prefix, suffix) {
    prefix = prefix || '';
    suffix = suffix || 'Item';

    let itemNumberNode = null;

    if (item.has('itemNumber')) {
      if (prefix === 'Deleted ') {
        itemNumberNode = '';
      } else {
        itemNumberNode = (
          <a onClick={() => this._scrollToItemRow(item)}>
            {item.get('itemNumber')}
          </a>
        );
      }
    }

    return (
      <div className="af-list-item-number">
        <span className="af-list-item-number-prefix">{prefix} </span>
        <span className="af-list-item-number-value">
          <span>{suffix}</span>&nbsp;{itemNumberNode}
        </span>
      </div>
    );
  },

  _getListItemUser(item) {
    return <UserAvatar user={item.get('user').toJS()} />;
  },

  _getListItemTitle(item, itemTitle) {
    let title = itemTitle || item.has('itemTitle') ? item.get('itemTitle') : '';

    if (typeof title === 'undefined') title = '';

    let dash = '';

    if (`${title}`.length > 1) dash = ' | ';

    return (
      <span className="af-list-item-title">
        <span> </span>
        {dash} {title}
      </span>
    );
  },

  _getListItemTimeStamp(item) {
    let createdOn = item.get('createdOn');

    /**
     * Create a local moment using the server createdOn stamp (it is UTC), but apply the local timezone offset
     *
     * TODO: consider adding a function to time util that creates a local moment from a utc timestamp
     */
    let momLocal = getLocalMoment(createdOn);
    let date = momLocal.format('L');
    let time = momLocal.format('h:mm:ss a');

    return (
      <div className="af-list-item-time-stamp">
        <div className="af-list-item-time-stamp-date">{date}</div>
        <span></span>
        <div className="af-list-item-time-stamp-time">{time}</div>
      </div>
    );
  },

  _getPaginationNode() {
    let state = this.state.activityAudit,
      pageCount = state.getIn(['list', 'pageCount']),
      currentPage = state.get('currentPage');

    return (
      <SimplePager
        pageCount={pageCount}
        currentPage={currentPage}
        onGoToPage={this._goToPage}
      />
    );
  },

  componentDidMount() {
    this._populate();
  },

  _populate(params) {
    params = params || this.context.router.state.params;

    const { teamId, eventId, showId } = params;

    ActivityAuditListActions.populateForShow(teamId, eventId, showId, 1);
  },

  _goToPage(pageNum) {
    ActivityAuditListActions.changePage(pageNum);
  },

  _isLatestItemRowChangeForRow(item) {
    const { activityAudit } = this.state;
    const items = activityAudit.getIn(['list', 'items']);

    const rowIdPath = ['payload', 'rowId'];
    const titlePath = ['payload', 'changes', 'rteTitleState'];
    const descriptionPath = ['payload', 'changes', 'rteDescriptionState'];
    const durationPath = ['payload', 'changes', 'durationInSeconds'];
    // const presetPath = ['payload', 'changes', 'presetDurationInSeconds'];
    // const startOnPath = ['payload', 'changes', 'startOn'];

    const method = item.get('method');
    const createdOn = item.get('createdOn');
    const rowId = item.getIn(rowIdPath);
    const title = item.getIn(titlePath);
    const description = item.getIn(descriptionPath);
    const durationInSeconds = item.getIn(durationPath);
    // const presetDurationInSeconds = item.getIn(presetPath);
    // const startOn = item.getIn(startOnPath);

    const moreRecentChangeFound = items.find((actItem) => {
      const methodMatch = actItem.get('method') === method;
      const rowMatch = actItem.getIn(rowIdPath) === rowId;

      let cellMatch = false;

      const actCreatedOn = actItem.get('createdOn');
      const actTitle = actItem.getIn(titlePath);
      const actDescription = actItem.getIn(descriptionPath);
      const actDurationInSeconds = actItem.getIn(durationPath);
      // const actPresetDurationInSeconds = actItem.getIn(presetPath);
      // const actStartOn = actItem.getIn(startOnPath);

      if (actTitle && title) cellMatch = true;
      if (actDescription && description) cellMatch = true;
      if (actDurationInSeconds && durationInSeconds) cellMatch = true;
      if (actDurationInSeconds && durationInSeconds) cellMatch = true;

      return methodMatch && rowMatch && cellMatch && actCreatedOn > createdOn;
    });

    return moreRecentChangeFound ? false : true;
  },

  _isLatestCellChangeForCell(item) {
    const { activityAudit } = this.state;
    const items = activityAudit.getIn(['list', 'items']);

    const rowIdPath = ['payload', 'rowId'];
    const columnIdPath = ['payload', 'columnId'];

    const method = item.get('method');
    const createdOn = item.get('createdOn');
    const rowId = item.getIn(rowIdPath);
    const columnId = item.getIn(columnIdPath);

    const moreRecentChangeFound = items.find((actItem) => {
      const methodMatch = actItem.get('method') === method;
      const rowMatch = actItem.getIn(rowIdPath) === rowId;
      const columnMatch = actItem.getIn(columnIdPath) === columnId;
      const actCreatedOn = actItem.get('createdOn');

      return methodMatch && rowMatch && columnMatch && actCreatedOn > createdOn;
    });

    return moreRecentChangeFound ? false : true;
  },
});
